var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraduateCap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.3845 9.15198L44 11.7333V32.2666H85.0667L86.4219 29.6677L45.3845 9.15198Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6155 9.15198L44 11.7333V32.2666H2.93333L1.57812 29.6677L42.6155 9.15198Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6155 55.3814L44 52.8001V32.2667H2.93333L1.57812 34.8657L42.6155 55.3814Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3845 55.3814L44 52.8001V32.2667H85.0667L86.4219 34.8657L45.3845 55.3814Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0671 35.2C86.6872 35.2 88.0005 33.8867 88.0005 32.2667C88.0005 30.6467 86.6872 29.3334 85.0671 29.3334C83.4471 29.3334 82.1338 30.6467 82.1338 32.2667C82.1338 33.8867 83.4471 35.2 85.0671 35.2Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.93333 35.2C4.55337 35.2 5.86667 33.8867 5.86667 32.2667C5.86667 30.6467 4.55337 29.3334 2.93333 29.3334C1.3133 29.3334 0 30.6467 0 32.2667C0 33.8867 1.3133 35.2 2.93333 35.2Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9997 55.7334C45.6198 55.7334 46.9331 54.4201 46.9331 52.8C46.9331 51.18 45.6198 49.8667 43.9997 49.8667C42.3797 49.8667 41.0664 51.18 41.0664 52.8C41.0664 54.4201 42.3797 55.7334 43.9997 55.7334Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9997 14.6667C45.6198 14.6667 46.9331 13.3534 46.9331 11.7334C46.9331 10.1133 45.6198 8.80005 43.9997 8.80005C42.3797 8.80005 41.0664 10.1133 41.0664 11.7334C41.0664 13.3534 42.3797 14.6667 43.9997 14.6667Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9942 58.6303C44.7231 59.2273 43.2597 59.2701 41.9771 58.6982C34.4225 55.3298 25.5473 50.0999 19.0415 46.7337C18.3813 46.3921 17.6006 46.8745 17.6006 47.6178V57.38C17.6006 58.4813 18.2081 59.4963 19.1765 60.0208C28.1276 64.8689 32.7258 67.369 41.4443 71.3964C43.0595 72.1425 44.929 72.12 46.5329 71.3499C57.3523 66.1554 61.9409 64.0286 68.9087 60.0308C69.8342 59.4998 70.4006 58.5114 70.4006 57.4444V48.618C70.4006 47.8747 69.6188 47.3903 68.9522 47.7194C62.4382 50.9354 53.5528 55.0804 45.9942 58.6303Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11 42.1257V66.6279C11 67.9397 10.104 69 9 69C7.896 69 7 67.9397 7 66.6279V40L11 42.1257Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5 70C5 71.267 6.31467 73.7106 7.43663 75.5653C8.16067 76.7622 9.83933 76.7622 10.5634 75.5653C11.6853 73.7106 13 71.267 13 70C13 67.79 11.21 66 9 66C6.79 66 5 67.79 5 70Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M38 40.6065V24.5212C38 22.969 39.6912 22.0084 41.0243 22.8034L55.0115 31.1439C56.3368 31.9342 56.3059 33.8639 54.956 34.6114L40.9688 42.3562C39.6358 43.0943 38 42.1302 38 40.6065Z",
    fill: "#0070FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduateCap);
export default __webpack_public_path__ + "static/media/graduate-cap.07a1d069dac3a1ab922dc80c0295bad6.svg";
export { ForwardRef as ReactComponent };